import gettext from '@sdk/lang/gettext';
import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { MoreOptionsMenuOption } from '@sdk/components/ui/moreOptionsMenu.types';

import { FooterMoreActionsOptions } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/TimesheetViewModalManagerFooter/timesheetViewModalManagerFooter.types';

export const getMoreButtonOptions = ({
  timesheetStatus,
  shouldHideEdit,
  isAdmin,
}: {
  timesheetStatus: TimesheetStatus;
  shouldHideEdit: boolean;
  isAdmin: boolean;
}): MoreOptionsMenuOption[] => {
  if (timesheetStatus === TimesheetStatus.approved) {
    if (isAdmin) {
      return [
        {
          key: FooterMoreActionsOptions.markPending,
          label: gettext('Mark as pending'),
          value: FooterMoreActionsOptions.markPending,
        },
      ];
    }
    return [];
  }

  if (timesheetStatus === TimesheetStatus.pendingConsent) {
    return [
      {
        key: FooterMoreActionsOptions.approve,
        label: gettext('Approve'),
        value: FooterMoreActionsOptions.approve,
        disabled: true,
        tooltipText: gettext(
          "Timesheets can't be approved when they are pending consent from employees."
        ),
      },
    ];
  }

  if (shouldHideEdit) {
    return [];
  }

  return [
    {
      key: FooterMoreActionsOptions.edit,
      label: gettext('Edit timesheet'),
      value: FooterMoreActionsOptions.edit,
    },
  ];
};
